export const categoryList = [
  { id: 'all', name: '全部分类', icon: 'ri-apps-line' },
  { id: 'chess', name: '棋牌游戏', icon: 'ri-bard-line' },
  { id: 'esports', name: '电子竞技', icon: 'ri-computer-line' },
  { id: 'live', name: '真人娱乐', icon: 'ri-live-line' },
  { id: 'slot', name: '电子游艺', icon: 'ri-slideshow-2-line' },
  { id: 'sport', name: '体育赛事', icon: 'ri-football-line' },
  { id: 'fishing', name: '捕鱼游戏', icon: 'ri-anchor-line' },
];

export const categoryGames = [
  {
    id: 1,
    category: 'chess',
    name: '欢乐斗地主',
    description: '经典扑克玩法，三人同台竞技，炸弹连击爽翻天',
    players: '230万人同时在线',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20playing%20cards%20arranged%20in%20a%20dramatic%20fan%20pattern%20on%20dark%20wooden%20surface%2C%20warm%20cinematic%20lighting%2C%20classic%20card%20game%20aesthetic%2C%20rich%20colorful%20suits%20with%20deep%20shadows%20and%20premium%20texture&width=600&height=400&seq=game-ddz-01&orientation=landscape',
  },
  {
    id: 2,
    category: 'chess',
    name: '国标麻将',
    description: '正宗国标规则，真人匹配，胡牌手感一流',
    players: '186万人同时在线',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20mahjong%20tiles%20arranged%20in%20neat%20rows%20on%20bamboo%20mat%20surface%2C%20warm%20ambient%20lighting%2C%20Chinese%20game%20aesthetic%2C%20rich%20carved%20tiles%20with%20beautiful%20traditional%20patterns%2C%20elegant%20composition&width=600&height=400&seq=game-mj-01&orientation=landscape',
  },
  {
    id: 3,
    category: 'chess',
    name: '牛牛炸翻天',
    description: '五人抢庄模式，倍率可调，刺激翻倍赢',
    players: '142万人同时在线',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20poker%20chips%20stacked%20in%20elegant%20columns%20on%20green%20felt%20table%20with%20playing%20cards%2C%20casino%20atmosphere%20with%20dramatic%20spotlight%20lighting%2C%20high-end%20gaming%20table%20aesthetic%2C%20professional%20photography&width=600&height=400&seq=game-nn-01&orientation=landscape',
  },
  {
    id: 4,
    category: 'esports',
    name: 'LOL 赛事竞猜',
    description: '英雄联盟全球赛事实时竞猜，赔率透明公正',
    players: '310万人参与',
    imageUrl: 'https://readdy.ai/api/search-image?query=Esports%20tournament%20arena%20with%20massive%20LED%20screens%20showing%20gameplay%2C%20vibrant%20neon%20blue%20and%20purple%20lighting%2C%20professional%20competitive%20gaming%20atmosphere%2C%20crowd%20energy%20and%20drama%2C%20cinematic%20wide%20shot&width=600&height=400&seq=game-lol-01&orientation=landscape',
  },
  {
    id: 5,
    category: 'esports',
    name: 'DOTA2 巅峰对决',
    description: 'DOTA2 国际邀请赛全程覆盖，高手云集',
    players: '198万人参与',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20esports%20arena%20with%20dramatic%20red%20and%20orange%20lighting%20accents%2C%20futuristic%20gaming%20setup%20with%20multiple%20monitors%2C%20intense%20competitive%20atmosphere%2C%20wide%20angle%20cinematic%20view&width=600&height=400&seq=game-dota-01&orientation=landscape',
  },
  {
    id: 6,
    category: 'esports',
    name: 'CS2 枪王之战',
    description: '反恐精英2赛事竞猜，精准预测射击胜负',
    players: '256万人参与',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20gaming%20setup%20with%20RGB%20keyboard%20and%20high-end%20monitor%20displaying%20first%20person%20shooter%20game%2C%20dark%20room%20with%20colorful%20ambient%20LED%20strips%2C%20immersed%20gamer%20atmosphere%2C%20high-tech%20esports%20aesthetic&width=600&height=400&seq=game-cs2-01&orientation=landscape',
  },
  {
    id: 7,
    category: 'live',
    name: '百家乐极速版',
    description: '真人荷官实时发牌，极速下注无需等待',
    players: '420万人同时在线',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20casino%20dealer%20at%20premium%20gaming%20table%20with%20cards%20and%20chips%2C%20luxurious%20red%20and%20gold%20interior%2C%20dramatic%20warm%20lighting%2C%20high-end%20live%20casino%20studio%20atmosphere%2C%20professional%20photography&width=600&height=400&seq=game-bjl-01&orientation=landscape',
  },
  {
    id: 8,
    category: 'live',
    name: '龙虎斗在线',
    description: '经典龙虎对决，秒速开奖，体验纯粹刺激',
    players: '312万人同时在线',
    imageUrl: 'https://readdy.ai/api/search-image?query=Asian%20dragon%20and%20tiger%20artwork%20theme%20with%20ornate%20golden%20dragon%20statue%20and%20powerful%20tiger%20imagery%2C%20rich%20red%20and%20gold%20color%20palette%2C%20traditional%20Chinese%20casino%20aesthetic%2C%20dramatic%20luxury%20visuals&width=600&height=400&seq=game-lhd-01&orientation=landscape',
  },
  {
    id: 9,
    category: 'slot',
    name: '神话三国',
    description: '三国名将齐聚，3D特效炸裂，免费转停不下来',
    players: '268万人同时在线',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mythical%20Three%20Kingdoms%20themed%20digital%20game%20with%20ancient%20Chinese%20warriors%20and%20golden%20treasures%2C%20epic%20digital%20art%20style%2C%20rich%20colorful%20game%20interface%20with%20stunning%20visual%20effects%2C%20dynamic%20composition&width=600&height=400&seq=game-sg-01&orientation=landscape',
  },
  {
    id: 10,
    category: 'slot',
    name: '深海宝藏',
    description: '潜入海底寻宝，触发宝箱大奖，倍率爆表',
    players: '215万人同时在线',
    imageUrl: 'https://readdy.ai/api/search-image?query=Magical%20underwater%20treasure%20chest%20glowing%20with%20golden%20light%20surrounded%20by%20colorful%20gems%20and%20coins%2C%20mysterious%20deep%20ocean%20setting%20with%20coral%20and%20marine%20creatures%2C%20fantasy%20game%20aesthetic%2C%20rich%20vibrant%20colors&width=600&height=400&seq=game-treasure-01&orientation=landscape',
  },
  {
    id: 11,
    category: 'sport',
    name: '英超联赛',
    description: '英格兰超级联赛全程竞猜，实时赔率更新',
    players: '540万人参与',
    imageUrl: 'https://readdy.ai/api/search-image?query=Majestic%20football%20stadium%20filled%20with%20cheering%20fans%20during%20night%20match%2C%20brilliant%20floodlights%20illuminating%20lush%20green%20pitch%2C%20dramatic%20sports%20atmosphere%2C%20professional%20wide%20angle%20photography%20with%20energy%20and%20excitement&width=600&height=400&seq=game-yingchao-01&orientation=landscape',
  },
  {
    id: 12,
    category: 'sport',
    name: 'NBA 常规赛',
    description: 'NBA 每日赛事竞猜，数据全面，预测精准',
    players: '386万人参与',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20arena%20during%20intense%20game%20with%20players%20in%20mid-air%20action%2C%20dazzling%20arena%20lights%20and%20crowd%20silhouettes%2C%20high-energy%20sports%20photography%20style%2C%20dynamic%20motion%20and%20dramatic%20lighting&width=600&height=400&seq=game-nba-01&orientation=landscape',
  },
  {
    id: 13,
    category: 'fishing',
    name: '疯狂捕鱼',
    description: '四人同屏捕鱼，炮台升级，BOSS鱼群赢大奖',
    players: '320万人同时在线',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20underwater%20fishing%20game%20scene%20with%20giant%20fish%20and%20treasure%20chests%2C%20bright%20coral%20reef%20environment%20with%20exotic%20tropical%20fish%20swarming%2C%20arcade%20game%20aesthetic%2C%20vibrant%20cartoon%20style%20illustration&width=600&height=400&seq=game-fish-01&orientation=landscape',
  },
  {
    id: 14,
    category: 'fishing',
    name: '深海猎手',
    description: '单人挑战深海巨兽，高额倍率，一击暴富',
    players: '198万人同时在线',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20deep%20ocean%20scene%20with%20giant%20sea%20monster%20fish%20and%20glowing%20lantern%20fish%2C%20dark%20blue%20abyss%20with%20bioluminescent%20creatures%20and%20treasure%2C%20mysterious%20fantasy%20ocean%20atmosphere%2C%20epic%20digital%20art%20style&width=600&height=400&seq=game-deepsea-01&orientation=landscape',
  },
];